// extracted by mini-css-extract-plugin
export default {"ContentTabHead":"QwB4KOOORe1lfb16HI3T"};